export default function readSections(readDB, doc, form) {
  return function () {
    if (!form) return
    readDB({paths: [{collection: 'forms', doc}, {collection: 'sections'}]}, 'sections')
  }
}
